import {
  type CustomRenderer,
  type CustomCell,
  GridCellKind,
  drawTextCell
} from "@glideapps/glide-data-grid";
import { formatDistanceToNow } from "date-fns";

export interface TimestampCellProps {
    readonly kind: "timestamp-cell";
    /* The current value of the datetime cell. */
    readonly timestamp: Date | number | string;
}

export type TimestampCell = CustomCell<TimestampCellProps>;

const renderer: CustomRenderer<TimestampCell> = {
  kind: GridCellKind.Custom,
  isMatch: (cell: CustomCell): cell is TimestampCell => (cell.data as any).kind === "timestamp-cell",
  draw: (args, cell) => {
    const { timestamp } = cell.data;
    // TODO: better parsing
    // const date: number = Date.parse(timestamp.toString());
    const text = formatDistanceToNow(timestamp, { addSuffix: true, includeSeconds: true });
    drawTextCell(args, text, cell.contentAlign);
    return true
  }
};

export default renderer;
